import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Edit, Trash2, Star } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { formatDate } from "@/lib/utils-format";
import { Btn } from "@/components/admin/AdminUI";

const STATUS_LABELS = { draft: "Borrador", scheduled: "Programado", published: "Publicado", archived: "Archivado" };
const STATUS_COLORS = { draft: "bg-yellow-100 text-yellow-800", scheduled: "bg-blue-100 text-blue-800", published: "bg-green-100 text-green-800", archived: "bg-gray-200 text-gray-700" };

export default function ArticlesAdmin() {
  const [articles, setArticles] = useState([]);
  const [filter, setFilter] = useState("");
  const [search, setSearch] = useState("");

  const load = () => {
    let url = "/admin/articles?";
    if (filter) url += `status=${filter}&`;
    if (search) url += `search=${encodeURIComponent(search)}`;
    api.get(url).then((r) => setArticles(r.data || [])).catch(() => {});
  };
  useEffect(load, [filter, search]);

  const del = async (id) => {
    if (!window.confirm("¿Eliminar este artículo?")) return;
    await api.delete(`/admin/articles/${id}`);
    toast.success("Artículo eliminado");
    load();
  };

  return (
    <div>
      <header className="flex items-center justify-between mb-8">
        <h1 className="font-serif text-4xl tracking-tight">Artículos</h1>
        <Link to="/admin/articulos/nuevo"><Btn variant="accent" data-testid="new-article-btn"><Plus size={15} /> Nuevo artículo</Btn></Link>
      </header>

      <div className="flex flex-wrap gap-3 mb-6">
        <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Buscar…"
          className="bg-white border border-sunset-border px-3 py-2 text-sm focus:outline-none focus:border-sunset-accent" />
        <select value={filter} onChange={(e) => setFilter(e.target.value)}
          className="bg-white border border-sunset-border px-3 py-2 text-sm focus:outline-none focus:border-sunset-accent">
          <option value="">Todos los estados</option>
          {Object.entries(STATUS_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
      </div>

      <div className="bg-white border border-sunset-border">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-sunset-border text-left text-xs uppercase tracking-wider text-sunset-muted">
              <th className="px-5 py-3">Título</th>
              <th className="px-5 py-3">Categoría</th>
              <th className="px-5 py-3">Estado</th>
              <th className="px-5 py-3">Fecha</th>
              <th className="px-5 py-3 text-right">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {articles.map((a) => (
              <tr key={a.id} className="border-b border-sunset-border/60 hover:bg-sunset-bg" data-testid={`article-row-${a.id}`}>
                <td className="px-5 py-4 font-medium flex items-center gap-2">
                  {a.featured && <Star size={14} className="text-sunset-accent fill-sunset-accent" />}
                  {a.title}
                </td>
                <td className="px-5 py-4 text-sunset-muted">{a.category?.name || "—"}</td>
                <td className="px-5 py-4"><span className={`text-xs px-2 py-1 rounded ${STATUS_COLORS[a.status]}`}>{STATUS_LABELS[a.status]}</span></td>
                <td className="px-5 py-4 text-sunset-muted">{a.status === "scheduled" ? formatDate(a.scheduled_at) : formatDate(a.published_at || a.created_at)}</td>
                <td className="px-5 py-4">
                  <div className="flex items-center justify-end gap-2">
                    <Link to={`/admin/articulos/${a.id}`} className="p-2 hover:text-sunset-accent" data-testid={`edit-article-${a.id}`}><Edit size={16} /></Link>
                    <button onClick={() => del(a.id)} className="p-2 hover:text-red-600" data-testid={`delete-article-${a.id}`}><Trash2 size={16} /></button>
                  </div>
                </td>
              </tr>
            ))}
            {articles.length === 0 && <tr><td colSpan={5} className="px-5 py-10 text-center text-sunset-muted">No hay artículos.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
